(function () {
  const form = document.getElementById('cart');
  const invoice = document.getElementById('cart-invoice');
  if (!form || !invoice) return;

  // Prevent change events from our fields from bubbling up to Dawn's
  // <cart-items>, which would mis-handle them as quantity updates.
  invoice.addEventListener('change', function (e) {
    e.stopPropagation();
  });

  const radios = form.querySelectorAll('input[name="attributes[tipo_utente]"]');
  const companyGroup = invoice.querySelector('.company-fields');
  const enduserGroup = invoice.querySelector('.enduser-fields');
  const message = invoice.querySelector('.cart-invoice__message');

  const cf = form.querySelector('input[name="attributes[codice_fiscale]"]');
  const company = form.querySelector('input[name="attributes[ragione_sociale]"]');
  const cfCompany = form.querySelector('input[name="attributes[codice_fiscale_azienda]"]');
  const piva = form.querySelector('input[name="attributes[partita_iva]"]');
  const pec = form.querySelector('input[name="attributes[pec]"]');
  const sdi = form.querySelector('input[name="attributes[sdi]"]');

  function setRequiredFields(userType) {
    if (userType === 'Privato') {
      enduserGroup.hidden = false;
      companyGroup.hidden = true;
      cf.required = true;
      company.required = false;
      cfCompany.required = false;
      piva.required = false;
    } else if (userType === 'Azienda') {
      enduserGroup.hidden = true;
      companyGroup.hidden = false;
      cf.required = false;
      company.required = true;
      cfCompany.required = true;
      piva.required = true;
    } else {
      enduserGroup.hidden = true;
      companyGroup.hidden = true;
      cf.required = false;
      company.required = false;
      cfCompany.required = false;
      piva.required = false;
      cf.value = '';
      piva.value = '';
      company.value = '';
      cfCompany.value = '';
      sdi.value = '';
      pec.value = '';
    }
  }

  radios.forEach(function (radio) {
    radio.addEventListener('change', function () {
      message.hidden = true;
      setRequiredFields(this.value);
    });
  });

  // Block checkout if "Azienda" is selected without either PEC or SDI
  form.addEventListener('submit', function (e) {
    const checked = form.querySelector('input[name="attributes[tipo_utente]"]:checked');
    const userType = checked ? checked.value : '';
    if (userType === 'Azienda' && pec.value.trim() === '' && sdi.value.trim() === '') {
      e.preventDefault();
      message.hidden = false;
      invoice.open = true;
    } else {
      message.hidden = true;
    }
  });

  // Keep the panel open when proceeding to checkout
  const checkoutBtn = document.getElementById('checkout');
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function () {
      const checked = form.querySelector('input[name="attributes[tipo_utente]"]:checked');
      if (checked && checked.value) invoice.open = true;
    });
  }

  // Align the UI with the radio already selected on page load
  const checkedOnLoad = form.querySelector('input[name="attributes[tipo_utente]"]:checked');
  setRequiredFields(checkedOnLoad ? checkedOnLoad.value : '');
})();
